import { DECK_SIZE } from './constants';
import type { CardData, HandCard } from '../types/card';

/** 不足分だけを補充する。既存の固定デッキは書き換えない。 */
export function fillDeck(
  deck: HandCard[],
  pool: CardData[],
  createId: (cardId: string) => string,
  random: () => number = Math.random,
): HandCard[] {
  if (deck.length >= DECK_SIZE) return [...deck];

  const counts = new Map<string, number>();
  for (const card of deck) counts.set(card.id, (counts.get(card.id) ?? 0) + 1);

  // 同じカードの複数行を「別種類」と数えない。
  const candidates = new Map<string, { card: CardData; remaining: number }>();
  for (const card of pool) {
    if (!['monster', 'magic', 'field', 'phasecard'].includes(card.type)) continue;
    const limit = card.isForbidden ? 1 : 3;
    const remaining = Math.max(0, limit - (counts.get(card.id) ?? 0));
    const existing = candidates.get(card.id);
    if (!existing || remaining < existing.remaining) {
      candidates.set(card.id, { card, remaining });
    }
  }
  const available = Array.from(candidates.values()).filter(c => c.remaining > 0);
  const capacity = available.reduce((sum, c) => sum + c.remaining, 0);
  if (capacity < DECK_SIZE - deck.length) {
    throw new RangeError(`カードの採用上限内では${DECK_SIZE}枚のデッキを作成できません（最大${deck.length + capacity}枚）`);
  }

  const result = [...deck];
  while (result.length < DECK_SIZE) {
    const value = random();
    if (!Number.isFinite(value) || value < 0 || value >= 1) {
      throw new RangeError('乱数は0以上1未満である必要があります');
    }
    const index = Math.floor(value * available.length);
    const candidate = available[index];
    result.push({ ...candidate.card, uniqueId: createId(candidate.card.id) });
    candidate.remaining -= 1;
    if (candidate.remaining === 0) available.splice(index, 1);
  }
  return result;
}
